

// ---Attributes
const attributes = [
  {
    id: 1,
    category_id_not: 3,
    name: [
      { inputName: "Length", inputType: "textBox", unit: "cm" },
      { inputName: "Width", inputType: "textBox", unit: "cm" },
      { inputName: "Height", inputType: "textBox", unit: "cm" },
      { inputName: "Weight", inputType: "textBox", unit: "kg" },

    ],
  },
];

const certifications = [
    {id: 4 ,  name : 'SABER'},
    {id: 5 ,  name : 'SASO'}
]

const transportType = [
  {id : 1, value : 'AIR', label : 'Air'},
  {id : 2, value : 'SHIP', label : 'Ship'},
  {id : 3, value : 'ROAD', label : 'By Road'}

]

// --------------------Taxation--------------

const taxTypes = [
  {id: 1, name :'PERCENTAGE', value :'PERCENTAGE'},
  // {id: 2, name :'FLAT', value :'FLAT'}
]

// ---------------PRICING POLICY-------------
const pricingPolicyOptions = {
  standard_pricing : {label : 'Standard Pricing', value : 'STANDARD_POLICY'},
  distributor_discount : {label : 'Distributor Discount', value : 'DISTRIBUTOR_POLICY'},
  manufacture_discount : {label : 'Manufacture Discount', value : 'MANUFACTURE_POLICY'},
}





// ----------------Unit----------------
const unitTypes = [
  {id : 1, name : 'Each(Ea)' ,value : 'Ea'},
  // {id : 2, name : 'Lot'}
]

const modules  = {
  Menu: 1,
  Dashboard: 2,
  Users: 3,
  Manufacturer: 4,
  Distributors: 5,
  Customers: 6,
  Products: 7,
  SupportedProducts : 8,
  ProductCertification : 9,
  Quotations : 10,
  ApplicationSettings : 11
}
module.exports = {
  attributes,

  transportType,
  certifications,
  modules,
  taxTypes,
  unitTypes,
  pricingPolicyOptions
};
